module.exports = __webpack_public_path__ + "static/media/reject.a4f636d7.svg";